import { Injectable, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { LocalStorageService } from '../storage/local-storage.service';
import { NavigationHistoryDto } from '../model/navigation-history.dto';
import { isEqual } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class RouteHistoryService implements OnDestroy {
  routeNavigationHistory: NavigationHistoryDto[] = [];
  navigationHistory$ = new BehaviorSubject<NavigationHistoryDto[]>(this.routeNavigationHistory);
  maxHistory: number = 10;

  constructor(private _router: Router, private _title: Title, private _localStorageService: LocalStorageService) {
    this.routeNavigationHistory = this._localStorageService.getObject('mcRouteNavigationHistory') ?? [];
    this._router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
      this.updateHistory();
    });
  }

  navigationHistorySubscription$() {
    return this.navigationHistory$.asObservable();
  }

  public ngOnDestroy(): void {
    this.updateHistory();
  }

  updateHistory() {
    const urlTree = this._router.parseUrl(this._router.url);
    const url = urlTree.root.children['primary']?.segments.map((x) => x.path).join('/') ?? '/';
    const params = urlTree.queryParams;
    this.routeNavigationHistory.unshift({ url: url, params: params, title: this._title.getTitle() });
    this.pruneHistory();
    this._localStorageService.setObject('mcRouteNavigationHistory', this.routeNavigationHistory);
    this.navigationHistory$.next(this.routeNavigationHistory);
  }

  private pruneHistory() {
    //Lets filter out duplicates
    this.routeNavigationHistory = this.routeNavigationHistory.filter(
      (val, index, self) => index === self.findIndex((t) => t.url === val.url && t.title === val.title && isEqual(t.params, val.params))
    );
    //Lets limit ourselves to 10 items in history
    if (this.routeNavigationHistory.length > this.maxHistory) {
      this.routeNavigationHistory = this.routeNavigationHistory.slice(0, this.maxHistory);
    }
  }
}
